import React from 'react';

import { OfferTabs } from 'offer/components/offer-tabs';

// Tab list slot for Staff Quote Revisit. Renders today's tabs until the Billing tab is retired
// (#36377).
const TabList = () => <OfferTabs />;

export default TabList;
